export default "__VITE_ASSET__8tMOBhw4Go7z5XZcVNeM2Q__"